import React from "react";
import styles from "./GlobalChip.module.css";

const GlobalChip = ({ label, type = "default", size = "small", ...props }) => {
  return (
    <p className={`${styles.chip} ${styles[type]} ${styles[size]}`} {...props}>
      {label}
    </p>
  );
};

export default GlobalChip;
